import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { MetadataTag } from "../types";

export const getMetadataTagDetails = async (metadataTagId: string): Promise<MetadataTag> => {
  const collectionRef = collection(db, "metadataTags");

  const metadataTagSnapshot = await getDoc(doc(collectionRef, metadataTagId));

  const data = metadataTagSnapshot.data()!;

  return {
    id: metadataTagId,
    primaryTag: data.primaryTag,
    isMultiple: data.isMultiple,
    type: data.type,
    updatedAt: data.updatedAt,
    ...data,
  };
};
